const config = {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_abUrqTM1v",
    APP_CLIENT_ID: "2dt14nohfd8l5qj53vqb0ijp6m",
    IDENTITY_POOL_ID: "us-east-1:a7c7ac01-75fe-48de-bd93-d3c5712c906f"
  }
};

export default config;